import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'em-select-button-formly',
  templateUrl: './select-button.component.html'
})
export class SelectButtonTypeComponent extends FieldType {
}
